<hlm-dialog>
    <hlm-dialog-header>
        <h3 hlmDialogTitle class="font-semibold text-gray-700 text-2xl flex justify-between items-center">
            <span>
                <i class="ti ti-alert-octagon-filled text-2xl text-red-500 mr-2" *ngIf="data?.type === 'ALERT'"></i>
                <i class="ti ti-help-hexagon text-2xl text-orange-500 mr-2" *ngIf="data?.type == 'ACTIVATE'"></i>
                <i class="ti ti-help-hexagon text-2xl text-red-500 mr-2" *ngIf="data?.type == 'DELETE'"></i>
                {{data?.title}}
            </span>
            @if(data?.enableCloseIcon){ 
                <span 
                    class=" text-gray-500 rounded-full w-8 h-8 cursor-pointer hover:bg-gray-100 px-1.5 relative -top-4 left-4 flex items-center justify-center" 
                    (click)="cancelDialog()">
                    <i class="ti ti-x text-2xl" (click)="cancelDialog()"></i>
                </span>
            }
        </h3>
        <p hlmDialogDescription class="text-gray-700" [innerHTML]="data?.message"></p>
    </hlm-dialog-header>

    <hlm-dialog-footer class="mt-3 pt-2">
        <button hlmBtn (click)="closeDialog()" class="text-base hover:bg-gray-100 flex justify-center items-center border border-gray-300 text-gray-700 font-medium rounded-lg text-base px-3 py-2 h-10 min-w-18" >{{data?.button?.close}}</button>
        <button hlmBtn (click)="submitDialog()" class="text-base flex justify-center items-center text-gray-100 font-medium rounded-lg text-base px-3 py-2 h-10 min-w-18" [ngClass]="{'bg-red-500 hover:bg-red-600': (data?.type === 'ALERT' || data?.type === 'DELETE'), 'bg-primary': data?.type === 'ACTIVATE'}">{{data?.button?.submit}}</button>
    </hlm-dialog-footer>
</hlm-dialog>
